import './modules/bling';

import RaceResults from './modules/race-results';
import PresidentResults from './modules/president-sum';
import PowerBalance from './modules/balance-of-power';

// import { getMarket } from './modules/get-market';

import homepageRaces from '../data/homepage-races.json';
import omnibusLinks from '../data/omnibus-links.json';

const marketHomepageRaces = homepageRaces;

const intervalTime = 1 * 60 * 1000;
const marketDomain = window.pageInfo['marketInfo.domain'];

// const { id: marketID } = getMarket();

const insertOmnibusLink = domain => {
  const moreLink = $1('.results-more-link');
  if (domain == 'kentucky') {
    moreLink.style.display = 'none';
    return;
  }
  let market = domain;
  if (domain == 'elnuevoherald') {
    market = 'miamiherald';
  }
  const { public: url } = omnibusLinks.find(d => d.domain == market);

  moreLink.setAttribute('href', url);
};

async function fetchEVData(marketID) {
  const r = await fetch(
    `https://elections-api.mcclatchy.com/presidential-report/${marketID}/`
  );
  const data = await r.json();
  return data;
}

async function fetchRaceData(marketID) {
  const r = await fetch(
    `https://elections-api.mcclatchy.com/results/${marketID}`
  );
  const data = await r.json();
  return data;
}

async function fetchRaceByID(recordID) {
  const r = await fetch(
    `https://elections-api.mcclatchy.com/result/${recordID}`
  );
  const data = await r.json();
  return data;
}

async function fetchBOPData(marketID) {
  const r = await fetch(
    `https://elections-api.mcclatchy.com/report/${marketID}/House`
  );
  const r2 = await fetch(
    `https://elections-api.mcclatchy.com/report/${marketID}/Senate`
  );
  const house = await r.json();
  const senate = await r2.json();
  return { house, senate };
}

async function initResults() {
  const header = $1('.elections-2020 .results-header');
  const es = $1('.elections-2020').getAttribute('data-es') === 'true';

  const marketDomain = window.pageInfo['marketInfo.domain'];

  if (marketDomain == 'kansascity') {
    $1('.elections-2020').setAttribute('data-mar', marketDomain);
  }

  const headerText = es ? 'Resultados en vivo de' : 'Live results from';
  header.innerText = `${headerText} ${pageInfo['marketInfo.state']}${
    marketDomain == 'kansascity' ? ' and Kansas' : ''
  }`;

  const resultsGrid = $1('.results-grid');

  const raceIds = marketHomepageRaces[marketDomain].map(d => d.recordID);

  if (process.env.NODE_ENV === 'development') {
    // const { results } = await fetchRaceData(marketID);
    // console.log("Market Results: ",results);
  }

  const allData = await Promise.all(
    raceIds.map(async id => await fetchRaceByID(id))
  );

  console.log(allData);

  const allRaces = allData.map((data, i) => {
    const id = data.record_id;

    if (!id) {
      console.log(data);
      console.error('record_id not found');
      return null;
    }

    const resultDiv = document.createElement('div');
    resultDiv.className = 'election-group race-group';
    resultDiv.setAttribute('data-race', id);

    resultsGrid.appendChild(resultDiv);

    const raceResult = new RaceResults();

    raceResult
      .selection(`.election-group[data-race="${id}"`)
      .props({ pageMode: 'homepage', raceID: id })
      .data(data)
      .render();

    return { raceResult, id: raceIds[i] };
  });

  setInterval(async () => {
    console.log('Fetching new race data...');
    fetchNewResults(allRaces);
  }, intervalTime);
}

function fetchNewResults(allResults) {
  allResults.forEach(async ({ raceResult, id }, i, a) => {
    if (a[i] == null) return;
    const data = await fetchRaceByID(id);
    raceResult.data(data).render();
  });
}

async function initPresidentRace() {
  const { data } = await fetchEVData(1);
  const presResults = new PresidentResults();
  const es = $1('.elections-2020').getAttribute('data-es') === 'true';

  const checkPopVotes = data => {
    const liveKicker = $1('.live-kicker');
    const popVotes = data.Sumtable.Cand.map(d => d.PopVote).some(d => +d > 0);

    if (!popVotes) {
      liveKicker.innerText = es ? 'Resultados pronto' : 'Results Coming Soon';
      liveKicker.classList.add('live--off');
    } else {
      liveKicker.innerText = es ? 'EN VIVO' : 'Live';
      liveKicker.classList.remove('live--off');
    }
  };

  checkPopVotes(data);

  presResults.selection('.pres-ev-results').data(data).render();

  setInterval(async () => {
    console.log('Fetching new president results...');
    const { data } = await fetchEVData(1);
    checkPopVotes(data);
    renderPresData(presResults, data);
  }, intervalTime);
}

function renderPresData(presClass, data) {
  presClass.data(data).render();
}

async function initPowerBalance() {
  const { house, senate } = await fetchBOPData(1);

  const housePower = new PowerBalance('house');
  const senatePower = new PowerBalance('senate');

  housePower
    .selection('.bop-results--house .bop__graphic')
    .data(house)
    .render();

  senatePower
    .selection('.bop-results--senate .bop__graphic')
    .data(senate)
    .render();

  setInterval(async () => {
    console.log('Fetching new BOP results...');
    const { house, senate } = await fetchBOPData(1);
    renderNewBOPresults(housePower, house);
    renderNewBOPresults(senatePower, senate);
  }, intervalTime);
}

function renderNewBOPresults(powerClass, data) {
  powerClass.data(data).render;
}

function bigNewsOverride() {
  if ($1('.wps-body-main')) {
    const bg = $1('section.big-news');
    if (bg) {
      const elex = $1('.elections-2020');

      // bg.querySelector('.label h2').innerText = 'Election 2020';

      // const latestHead = bg.querySelector('h5.latest');
      // const latestLinks = bg.querySelector('h5.latest + div.grid');
      const leadPackage = bg.querySelector('.package + figure');

      // leadPackage.insertAdjacentElement('afterend', latestLinks);
      // leadPackage.insertAdjacentElement('afterend', latestHead);

      leadPackage.insertAdjacentElement('afterend', elex);
    }
  } else {
    console.log('Not in homepage mode');
  }
}

insertOmnibusLink(marketDomain);
initPresidentRace().catch(console.error);
initPowerBalance().catch(console.error);

document.addEventListener('DOMContentLoaded', function () {
  bigNewsOverride();
});
